import { useEffect, useState } from "react";

import { ICandidateAssessment } from "@/modules/assessments/assessments.types";
import { LanguagesIsoEnum } from "@/modules/assessments/types/test.interface";
import { AssessmentHttpService } from "@/modules/assessments/services/assessment-http.service";

export function useGetAssessment({
  assessmentId,
  locale,
}: {
  assessmentId?: string | number;
  locale: LanguagesIsoEnum;
}) {
  const [assessment, setAssessment] = useState<ICandidateAssessment>();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchAssessment = async () => {
      if (!assessmentId) {
        return;
      }

      try {
        setIsLoading(true);

        const inviteAssessment = await AssessmentHttpService.getCandidateAssessmentByID({
          assessmentId: Number(assessmentId),
          locale,
        });

        if (inviteAssessment) {
          setAssessment(inviteAssessment);
        }
      } catch (e: any) {
        console.error(e);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAssessment();
  }, [assessmentId, locale]);

  return { assessment, isLoading };
}
